<ng-container [ngSwitch]="riskGroupKey | slugify">
	<ng-container *ngSwitchCase="'conservative'">
		<div class="risk-profile-indicator color-models-palette-conservative" [dz-tooltip]="conservative" [dz-tooltip-hover]="true">
			<span></span>
		</div>
	</ng-container>
	<ng-container *ngSwitchCase="'moderate-conservative'">
		<div class="risk-profile-indicator color-models-palette-moderate-conservative" [dz-tooltip]="moderateConservative" [dz-tooltip-hover]="true">
			<span></span>
		</div>
	</ng-container>
	<ng-container *ngSwitchCase="'moderate'">
		<div class="risk-profile-indicator color-models-palette-moderate" [dz-tooltip]="moderate" [dz-tooltip-hover]="true">
			<span></span>
		</div>
	</ng-container>
	<ng-container *ngSwitchCase="'balanced'">
		<div class="risk-profile-indicator color-models-palette-balanced" [dz-tooltip]="balanced" [dz-tooltip-hover]="true">
			<span></span>
		</div>
	</ng-container>
	<ng-container *ngSwitchCase="'moderate-aggressive'">
		<div class="risk-profile-indicator color-models-palette-moderate-aggressive" [dz-tooltip]="moderateAggressive" [dz-tooltip-hover]="true">
			<span></span>
		</div>
	</ng-container>
	<ng-container *ngSwitchCase="'growth'">
		<div class="risk-profile-indicator color-models-palette-growth" [dz-tooltip]="growth" [dz-tooltip-hover]="true">
			<span></span>
		</div>
	</ng-container>
	<ng-container *ngSwitchCase="'aggressive'">
		<div class="risk-profile-indicator color-models-palette-aggressive" [dz-tooltip]="aggressive" [dz-tooltip-hover]="true">
			<span></span>
		</div>
	</ng-container>
</ng-container>

<ng-template #conservative>
	<div>
		<p class="text-bold" [dcrHTMLKey]="'RISK_CONSERVATIVE'">
			<span>Conservative</span>
		</p>
		<p dcrHTMLKey="RISK_CONSERVATIVE_SUB_TEXT">&lt;30% Equity</p>
	</div>
</ng-template>
<ng-template #moderateConservative>
	<div>
		<p class="text-bold" dcrHTMLKey="RISK_MODERATE_CONSERVATIVE">
			<span>Moderate Conservative</span>
		</p>
		<p dcrHTMLKey="RISK_MODERATE_CONSERVATIVE_SUB_TEXT">30%-50% Equity</p>
	</div>
</ng-template>
<ng-template #moderate>
	<div>
		<p class="text-bold" dcrHTMLKey="RISK_MODERATE">
			<span>Moderate</span>
		</p>
		<p dcrHTMLKey="RISK_MODERATE_SUB_TEXT">50%-65% Equity</p>
	</div>
</ng-template>
<ng-template #balanced>
	<div>
		<p class="text-bold" dcrHTMLKey="RISK_BALANCED">
			<span>Balanced</span>
		</p>
		<p dcrHTMLKey="RISK_BALANCED_SUB_TEXT">50%-65% Equity</p>
	</div>
</ng-template>
<ng-template #moderateAggressive>
	<div>
		<p class="text-bold" dcrHTMLKey="RISK_MODERATE_AGGRESSIVE">
			<span>Moderate Aggressive</span>
		</p>
		<p dcrHTMLKey="RISK_MODERATE_AGGRESSIVE_SUB_TEXT">65%-80% Equity</p>
	</div>
</ng-template>
<ng-template #growth>
	<div>
		<p class="text-bold" dcrHTMLKey="RISK_GROWTH">
			<span>Growth</span>
		</p>
		<p dcrHTMLKey="RISK_GROWTH_SUB_TEXT">65%-80% Equity</p>
	</div>
</ng-template>
<ng-template #aggressive>
	<div>
		<p class="text-bold" [dcrHTMLKey]="'RISK_AGGRESSIVE'">
			<span>Aggressive</span>
		</p>
		<p dcrHTMLKey="RISK_AGGRESSIVE_SUB_TEXT">&gt;80% Equity</p>
	</div>
</ng-template>
